// extracted by css-extract-rspack-plugin
export default {"frameworkCallOff":"yTAlhmavsVdO_9Ga__frameworkCallOff___","callOffCount":"bGYJ7DOCJ9wFLoAm__callOffCount___","callOffValue":"wLprtJQXQW8DOdeQ__callOffValue___"};